// SIMPLIFIED Auto-scheduling - only uses existing columns
// Works without additional database columns

export const generateRoundRobinSchedule = (teams, pouleId) => {
    if (!teams || teams.length < 2) {
        throw new Error('Minimaal 2 teams nodig voor een speelschema')
    }

    const matches = []
    const teamList = [...teams]

    // If odd number of teams, add a "bye" (null)
    if (teamList.length % 2 !== 0) {
        teamList.push(null)
    }

    const numTeams = teamList.length
    const numRounds = numTeams - 1
    const matchesPerRound = numTeams / 2

    // Round-robin algorithm
    for (let round = 0; round < numRounds; round++) {
        for (let match = 0; match < matchesPerRound; match++) {
            const home = teamList[match]
            const away = teamList[numTeams - 1 - match]

            // Skip if either team is a "bye"
            if (home && away) {
                matches.push({
                    home_team_id: home.id,
                    away_team_id: away.id,
                    poule_id: pouleId,
                    score_home: null,
                    score_away: null,
                    round: round + 1, // Add Round Number
                    round_name: `Speelronde ${round + 1}`
                })
            }
        }

        // Rotate teams (keep first team fixed)
        teamList.splice(1, 0, teamList.pop())
    }

    return matches
}

export const generateDoubleRoundRobin = (teams, pouleId) => {
    // Generate home and away matches
    const firstRound = generateRoundRobinSchedule(teams, pouleId)
    const numRoundsFirst = Math.max(...firstRound.map(m => m.round))

    // Create return matches (swap home/away and offset rounds)
    const secondRound = firstRound.map(match => ({
        ...match,
        home_team_id: match.away_team_id,
        away_team_id: match.home_team_id,
        score_home: null,
        score_away: null,
        round: match.round + numRoundsFirst,
        round_name: `Speelronde ${match.round + numRoundsFirst}`
    }))

    return [...firstRound, ...secondRound]
}
